// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__2ccde","modalFooterButton":"ModalNotes_modalFooterButton__MZykL"};